import React, { FC, FormEvent, useState } from 'react';
import _ from 'lodash';
import AutoCompleteInput from '../inputs/autoCompleteInput';
import { DashboardInterface } from '../../interfaces/dashboard.interface';

interface DashboardSelectInterface {
  data: DashboardInterface | null,
  searchedValue: string,
  setSearchedValue: (_newValue: string) => void,
  dashboardOptions: any,
  isErrorDashboardOptions: boolean,
  isRefetchingDashboardOptions: boolean,
  refetchDashboardOptions: () => void,
  setSelectedOption: (_newSelectedOption: number) => void,
  size?: 'small' | 'medium',
}

const DashboardSelect: FC<DashboardSelectInterface> = (props) => {
  const [
    selectedValue,
    setSelectedValue,
  ] = useState<DashboardInterface | null>(props.data || null);

  const debouncedRefetchDashboardsData = _.debounce(props.refetchDashboardOptions, 500);

  const onChangeAutoComplete = (event: FormEvent, newValue: DashboardInterface) => {
    if (newValue?.id) {
      setSelectedValue(newValue);
      props.setSelectedOption(newValue.id);
      props.setSearchedValue('');
    } else {
      setSelectedValue(null);
      props.setSelectedOption(0);
      props.setSearchedValue('');
    }
  };

  const onInputChangeAutoComplete = async (event: FormEvent, value: string) => {
    setSelectedValue(null);
    props.setSearchedValue(value);
    await debouncedRefetchDashboardsData();
  };

  if (props.isErrorDashboardOptions) {
    return <p>error!</p>;
  }

  return (
    <AutoCompleteInput
      key="dashboard"
      name="dashboard"
      label={props.data?.id ? 'Dashboard' : 'Default Dashboard'}
      placeholder="Search dashboard"
      options={props.dashboardOptions?.data?.data ? props.dashboardOptions.data.data : []}
      getOptionLabel={(option: DashboardInterface) => option?.name || ''}
      value={selectedValue}
      loading={props.isRefetchingDashboardOptions}
      onChange={(event: FormEvent, newValue: DashboardInterface) => (
        onChangeAutoComplete(event, newValue)
      )}
      inputValue={selectedValue?.name || props.searchedValue}
      onInputChange={async (event: FormEvent, value: string) => {
        await onInputChangeAutoComplete(event, value);
      }}
      isOptionEqualToValue={(option: DashboardInterface, value: DashboardInterface) => (
        option.id === value.id
      )}
      size={props.size}
      style={{ minWidth: '280px', backgroundColor: 'white', zIndex: 1000 }}
    />
  );
};

export default DashboardSelect;
